/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Requires_Local_MediaInputs */



/**
* | output |
* | --- |
* | "Please load a local media file to use offline sync." |
*
* @param {Offline_Sync_Requires_Local_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_requires_local_media = /** @type {((inputs?: Offline_Sync_Requires_Local_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Requires_Local_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez charger un fichier média local pour utiliser la synchronisation hors ligne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte laden Sie eine lokale Mediendatei, um die Offline-Synchronisierung zu verwenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica un file multimediale locale per usare la sincronizzazione offline.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузите локальный медиафайл, чтобы использовать оффлайн-синхронизацию.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga un archivo multimedia local para usar la sincronización sin conexión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请加载本地媒体文件以使用离线同步。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフライン同期を使用するには、ローカルメディアファイルを読み込んでください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफलाइन सिंक उपयोग करने के लिए कृपया एक स्थानीय मीडिया फ़ाइल लोड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregue um ficheiro multimédia local para usar a sincronização offline.")
	return /** @type {LocalizedString} */ ("Please load a local media file to use offline sync.")
});